import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { CleverTapConstents } from 'src/app/services/constants';
import { DataService } from 'src/app/services/data.service';
import { EmployeeDesignation } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-employment-details',
  templateUrl: './employment-details.component.html',
  styleUrls: ['./employment-details.component.scss']
})
export class EmploymentDetailsComponent implements OnInit {

  get isSalaried(): boolean{
    return this.employmentStatus === this.empDesignations[0]?.id;
  };

  userRegion: any = '';

  isValidPincode: boolean = false;

  workExperienceOptions: any;

  suggestions: string[] = [];

  companyList: any[] = [];

  employeeBusinessList: any;

  empBusinessName: any;

  isDisableBtn: boolean = true;

  employmentStatus = 1;
  empDesignations:EmployeeDesignation[] = [];

  empBusinessId?: null;

  netMonthlyProfitGreaterThanGross = false;

  isStudentMainApplicant:boolean = false;

  submitInterval:any;

  get currentApplicant(){
    return this.util.getCurrentApplicant;
  }


  salariedFormGroup: FormGroup = new FormGroup({
    'companyName': new FormControl('', [Validators.required]),
    'netIncome': new FormControl('', [Validators.required, Validators.pattern(/^[0-9]+$/)]),
    'workExperience': new FormControl('', [Validators.required]),
  });


  addressDetailFormGroup: FormGroup = new FormGroup({
    'addLine1': new FormControl('', [Validators.required]),
    'addLine2': new FormControl('', []),
    'area': new FormControl('', []),
    'pinCode': new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]),
  })


  selfEmpFormGroup: FormGroup = new FormGroup({
    'empBusiness': new FormControl('', [Validators.required]),
    'workExperience': new FormControl('', [Validators.required]),
    'monthlySales': new FormControl('', [Validators.required, Validators.pattern(/^[0-9]+$/)]),
    'netMonthlyProfit': new FormControl('', [Validators.required, Validators.pattern(/^[0-9]+$/)]),
    'gross': new FormControl('', [Validators.required, Validators.pattern(/^[0-9]+$/)]),
  });


  constructor(public util: UtilService, private data: DataService) {

  }


  ngOnInit(): void {
    this.init();
    this.util.userLoggedInEventCalled.subscribe(()=>{
      this.init();
    })
  }

  init(){
    const loanDetails =  this.util.loanDetails;
    if(!loanDetails) return;
    this.empDesignations = this.util.employeeDesignation;
    this.employmentStatus = this.empDesignations[0].id;
    this.isStudentMainApplicant = loanDetails.isStudentMainApplicant && !loanDetails.isSponser && this.currentApplicant.mainApplicant;
    if(this.isStudentMainApplicant){
      this.employmentStatus = loanDetails.isEmployed? this.empDesignations[0].id : this.empDesignations[1].id;
    }
    this.workExperienceOptions = this.data.getDataFromContantAll('employee_experience');
    this.employeeBusinessList = this.data.getDataFromContantAll('employee_business');
    this.util.setCache('kycTab', 'employment');
    this.submitInterval = 
    setInterval(() => {
    
      if(this.checkValidation()){
        clearInterval(this.submitInterval);
        this.saveEmpDetals();
      }
    },2000);
    this.util.cleverTapEventCall("Employment details",{
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
  }

  search() {
    this.util.handleRequests('get', this.util.getUrl('employement_companyname', [this.salariedFormGroup.get('companyName')?.value]), undefined, 'application/json', false, true, false).then((res: any) => {
      this.suggestions = res.content.length > 100 ? res.content.slice(0, 100) : res.content;
    });
  }

  getEmpBusiness(id: any, name: any) {
    this.selfEmpFormGroup.get('empBusiness')?.setValue(id);
    this.empBusinessName = name;
    this.empBusinessId = id;
  }
  getWorkExperience(id: string,name: string){

  }
  selectedExp!:string;
  updateWorkExperience(row: any) {
    if (this.isSalaried) {
      this.salariedFormGroup.get('workExperience')?.setValue(row.id);
      this.selectedExp = row.value;
    } else {
      this.selfEmpFormGroup.get('workExperience')?.setValue(row.id);
      this.selectedExp = row.value;
    }
  }


  saveEmpDetals() {
    
    let requestData = {
      "addressDTO": {
        "addressLine1": this.addressDetailFormGroup.get('addLine1')?.value,
        "addressLine2": this.addressDetailFormGroup.get('addLine2')?.value,
        "area": this.addressDetailFormGroup.get('area')?.value,
        "pincode": this.addressDetailFormGroup.get('pinCode')?.value
      },
      "employmentDetails": {
        "designationTypeId": this.employmentStatus,
        "employerName": this.isSalaried ? this.salariedFormGroup.get('companyName')?.value.companyName || this.salariedFormGroup.get('companyName')?.value : this.empBusinessName,
        "gistin": "",
        "grossReceiptsPerMonth": this.selfEmpFormGroup.get('gross')?.value,
        "loanId": this.util.loanDetails.loanId,
        "monthlyIncome": this.isSalaried ?this.salariedFormGroup.get('netIncome')?.value : this.selfEmpFormGroup.value['netMonthlyProfit'] ,
        "monthlySales": this.selfEmpFormGroup.get('monthlySales')?.value,
        "professionId": this.empBusinessId,
        "subCategoryId": this.empBusinessId,
        "typeOfBusinessId": null,
        "workExperienceId": this.isSalaried ? this.salariedFormGroup.get('workExperience')?.value : this.selfEmpFormGroup.get('workExperience')?.value
      }
    };
    let cleverTapJson = {
      'applicantType':(this.currentApplicant.mainApplicant !== null&& this.currentApplicant.mainApplicant == true) ? 'Main Applicant': 'Co-Applicant',
      'loanId': this.util.loanDetails.loanId,
      'productCode': this.util.loanDetails.productCategory,
    };
    this.util.cleverTapEventCall(CleverTapConstents.emp_details,cleverTapJson);
    console.log(this.util.loanDetails.product,this.util.loanDetails)
    this.util.handleRequests('put', this.util.getUrl('loan_saveEmp', [this.util.loanDetails.loanId, this.util.getCache('currentApplicant')]), requestData).then((res: any) => {
      this.util.getProducts().then(() => {
        this.util.cleverTapEventCall(CleverTapConstents.emp_details_complt,cleverTapJson);
        this.util.route('eligibility');
      })
    });
  }


  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }
  // openDropWorkExp(id: string) {
  //   $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  // }
  toggleEmpType(designationTypeId: any) {
    this.employmentStatus = designationTypeId;
  }

  getPincodeDetails() {
    this.userRegion = '';
    if (this.addressDetailFormGroup.get('pinCode')?.valid) {
      this.util.handleRequests('get', this.util.getUrl('user_region', [this.addressDetailFormGroup.get('pinCode')?.value])).then((res: any) => {
        if (res.status == 'SUCCESS' && res.content.length > 0) {
          this.userRegion = res.content[0].district.value + ', ' + res.content[0].district.state.shortName;
          
        }
        else {
          this.userRegion = 'Invalid'
        }
      })
    } else {
      return;
    }
  }

  checkValidation() {
    if (this.isSalaried) {
      if ((this.addressDetailFormGroup.valid && (this.userRegion.length && this.userRegion != 'Invalid') && this.salariedFormGroup.valid)) {
        return true
      } else {
        return false;
      }
    }
    else {
      if ((this.addressDetailFormGroup.valid && (this.userRegion.length && this.userRegion != 'Invalid') && this.selfEmpFormGroup.valid && !this.netMonthlyProfitGreaterThanGross)) {
        return true
      } else {
        return false;
      }
    }

  }

  onInput(event: any, formGroup: FormGroup, formControl: string) {
    let input = event.target.value;
    const numericInput = input.replace(/[^0-9]/g, '');
    formGroup.controls[formControl].setValue(numericInput);
  }

  netMonthlyProfitValidator(event: any, formGroup: FormGroup, formControl: string) {
    this.onInput(event,formGroup,formControl);
    let netMonthlyProfit = parseInt(this.selfEmpFormGroup.get('netMonthlyProfit')?.value);
    let gross = parseInt(this.selfEmpFormGroup.get('gross')?.value);
    if (netMonthlyProfit >= gross) {
      this.netMonthlyProfitGreaterThanGross = true;
    } else {
      this.netMonthlyProfitGreaterThanGross = false;
    }
  }





  ngOnDestroy(): void {
    clearInterval(this.submitInterval);
  }



}
